<template>
  <div class="racunovodstvo-nalozi">
    <purchase-create-edit
      v-if="active_purchase_popup"
      @closeMe="closePurchasePop"
      @create="createNewPurchase"
      @edit="editSinglePurchase"
      :is_edit="purchase_edit_mode"
      :purchase="purchaseData"
      :clanovi="all_users"
    ></purchase-create-edit>
    <!-- <DataLoader :is_on="loading" /> -->
    <div class="opening-folder">
      <div class="open-folder-line">
        <div class="open-folder-line-left">
          <div class="naplata-filters">
            <!-- <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  readonly
                  clearable
                  :label="$t('billing_page.filters.f1')"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  @click:append="menu1 = !menu1"
                  v-on="on"
                  class="case-date-picker rocista-date-picker"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="hr"
                v-model="date_range"
                range
                no-title
                :pickerDate.sync="pickerDate"
              >
              </v-date-picker>
            </v-menu> -->
            <CustomDropdown
                :id="'drop_single_type'"
                v-model="selected_type"
                :init_text="$t('components.general.office_management.purchase_group.select_type')"
                style="font-size: 0.8vw;"
                :drop_items="
                  services.map((p) => {
                    return {
                      naziv: p.name,
                      id: p.id,
                    };
                  })
                "
              />
              <CustomDropdown
                :id="'user_single_type'"
                v-model="selected_person"
                class="wider"
                :init_text="$t('components.general.office_management.purchase_group.select_person')"
                style="font-size: 0.8vw;"
                :drop_items="
                  all_users.map((p) => {
                    return {
                      naziv: p.value,
                      id: p.link,
                    };
                  })
                "
              />
              <div class="clear-filters" v-if="selected_person || selected_type" @click="clearAllFilters()">{{ $t('components.general.office_management.purchase_group.clear_filters') }}</div>
          </div>
        </div>
      </div>
    </div>
    <custom-spinner v-if="!purchase_groups" />
    <div v-else class="racunovodstvo-wrapper troskovnik-report-edit">
      <div
        class="racunovodstvo-left event-list-wrapper troskovnik-report-edit-left"
      >
        <div
          v-if="purchase_groups.length == 0"
          class="case-kalendar-event events-tab-view"
        >
          <div class="kalendar-event-details">
            <div class="case-kalendar-event-empty">
              {{ $t('components.general.office_management.purchase_group.no_purchases') }}
            </div>
          </div>
        </div>
        <div
          :class="[
            'case-kalendar-event events-tab-view empty-add-purchase-group',
          ]"
          @click="openNewModal()"
        >
          <div class="inside-text">
            <span class="first">+</span
            ><span class="second"> {{ $t('components.general.office_management.purchase_group.add_new_group') }}</span>
          </div>
        </div>
        <!-- chosen_nalog && nalog.id_troskovnik == chosen_nalog.id_troskovnik
              ? 'active'
              : '', 
              @click="setNalogView(nalog)"  -->
        <div
          v-for="(group, key) in finalni_arr_prikaza"
          :key="key"
          :class="[
            'case-kalendar-event events-tab-view',
            selected_group && selected_group.id == group.id ? 'active' : '',
          ]"
          @click="setGroupView(group)"
        >
          <div class="event-type-wrapper">
            <div :class="'vrsta-eventa event-red'" v-if="isFinished(group)">
              {{ $t('components.general.office_management.purchase_group.unfulfilled') }}
            </div>
            <div :class="'vrsta-eventa event-green'" v-else>{{ $t('components.general.office_management.purchase_group.fulfilled') }}</div>
            <div class="vrsta-eventa" v-if="group.purchase_group_type">#{{group.purchase_group_type.name}}</div>
          </div>
          <div class="kalendar-event-details">
            <div class="kalendar-event-title">{{ group.name }}</div>
            <div class="nalog-person">
              <span class="person-title">{{ $t('components.general.office_management.purchase_group.execution_period') }}: </span>
              <span class="">
                {{
                  group.from_timestamp ? `${getDate(group.from_timestamp)}` : ""
                }}
                -
                {{
                  group.deadline_timestamp
                    ? `${getDate(group.deadline_timestamp)}`
                    : ""
                }}
              </span>
            </div>
            <div class="nalog-person">
              <span class="person-title"> {{ $t('components.general.office_management.purchase_group.created_by') }}: </span>
              <span class="">
                {{ group.odvjetnik.ime }} {{ group.odvjetnik.prezime }}
              </span>
            </div>
            <div
              class="nalog-person"
              v-if="group.office_management_purchases.length > 0"
            >
              <span class="person-title"> {{ $t('components.general.office_management.purchase_group.total_items') }}: </span>
              <span class="">
                {{ group.office_management_purchases.length }}
              </span>
            </div>
            <div v-else class="nalog-person">
              <span class="person-title"> {{ $t('components.general.office_management.purchase_group.no_items_added') }} </span>
            </div>

            <div class="nalog-person" v-if="group.links.length > 0">
              <span class="person-title">
                {{ calcAttachments(group.links.length) }}
              </span>
            </div>

            <div class="buttons-wrapper two-btn">
              <div
                class="print-button icon-button"
                @click="openEditModal(group)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                >
                  <g>
                    <g>
                      <path
                        fill="#000"
                        d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                      ></path>
                    </g>
                  </g>
                </svg>
                {{ $t("racunovodstvo_nalozi.izvrsi_edit") }}
              </div>

              <!-- <div
                class="print-button icon-button"
                @click="downloadNalog(nalog)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.6975 0C5.89894 0 5.23277 0.648667 5.16304 1.49419C5.01724 3.26199 4.98035 5.03769 5.05247 6.80992C4.96541 6.81611 4.87837 6.82256 4.79135 6.82928L3.25379 6.94843C2.27103 7.02459 1.72166 8.18923 2.25222 9.07179C3.38376 10.9539 4.84177 12.5902 6.54854 13.8933L7.16454 14.3636C7.66395 14.745 8.33665 14.745 8.83606 14.3636L9.45206 13.8933C11.1588 12.5902 12.6169 10.9539 13.7484 9.07179C14.2789 8.18923 13.7296 7.02459 12.7468 6.94843L11.2093 6.82928C11.1222 6.82256 11.0352 6.81611 10.9481 6.80992C11.0203 5.03768 10.9834 3.26199 10.8376 1.49418C10.7678 0.648661 10.1017 0 9.3031 0H6.6975Z"
                    fill="black"
                  />
                  <path
                    d="M1.54839 15.0855C1.54839 14.6311 1.20177 14.2627 0.774192 14.2627C0.346618 14.2627 0 14.6311 0 15.0855V17.2798C0 18.3402 0.808779 19.1998 1.80645 19.1998H14.1935C15.1912 19.1998 16 18.3402 16 17.2798V15.0855C16 14.6311 15.6534 14.2627 15.2258 14.2627C14.7982 14.2627 14.4516 14.6311 14.4516 15.0855V17.2798C14.4516 17.4313 14.3361 17.5541 14.1935 17.5541H1.80645C1.66393 17.5541 1.54839 17.4313 1.54839 17.2798V15.0855Z"
                    fill="black"
                  />
                </svg>
                {{ $t("racunovodstvo_nalozi.download") }}
              </div> -->
              <div
              v-if="(group.office_management_purchases.length == 0)"
                class="print-button icon-button"
                @click="openDeleteGroupModal(group)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="15"
                  viewBox="0 0 12 15"
                >
                  <g>
                    <g>
                      <path
                        fill="#7b7b8a"
                        d="M11.934 3.295v.918a.459.459 0 0 1-.459.46H.46A.459.459 0 0 1 0 4.212v-.918c0-.634.514-1.147 1.148-1.147h2.524v-.46c0-.76.617-1.376 1.377-1.376h1.836c.76 0 1.377.616 1.377 1.377v.459h2.525c.633 0 1.147.513 1.147 1.147zM4.59 2.148h2.754v-.46a.46.46 0 0 0-.459-.458H5.05a.46.46 0 0 0-.459.459zm6.473 3.442c.082 0 .147.069.144.15l-.38 7.948A1.375 1.375 0 0 1 9.453 15h-6.97c-.736 0-1.34-.576-1.375-1.312l-.38-7.947a.143.143 0 0 1 .144-.15zm-3.26 7.115a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0z"
                      ></path>
                    </g>
                  </g>
                </svg>
                Obriši
              </div>
            </div>

            <!--    <div class="kalendar-event-case-name underline-item">
              {{ nalog.predmet.ime_predmeta }}
            </div>
            <div class="nalog-person">
              <span class="person-title">
                {{ $t("racunovodstvo_nalozi.holder") }}:
              </span>
              <span class="">
                {{
                  getAccountHolder(nalog.predmet.predmet_odvjetnik_connector)
                }}
              </span>
            </div>
            <div class="nalog-person">
              <span class="person-title">
                {{ $t("racunovodstvo_nalozi.date_created") }}:
              </span>
              <span class="">
                {{ getDate(nalog.time_created) }}
              </span>
            </div>
            <div v-if="nalog.is_invoiced" class="nalog-person">
              <span class="person-title">
                {{ $t("racunovodstvo_nalozi.racun_num") }}:
              </span>
              <span class="">
                {{ nalog.rn_number }}
              </span>
            </div>
            <div
              v-if="nalog.billing_types.id == 4"
              @click="openBreakdown()"
              class="kalendar-event-case-name nalog-breakdown underline-item"
            >
              <b>Otvori specifikaciju usluga</b>
            </div>
            <div class="buttons-wrapper">
              <div class="print-button icon-button" @click="openNalog(nalog)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="20"
                  viewBox="0 0 15 20"
                  id="SVGDoc"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xmlns:avocode="https://avocode.com/"
                >
                  <defs></defs>
                  <desc>Generated with Avocode.</desc>
                  <g>
                    <g>
                      <title>view_icon</title>
                      <path
                        fill="#2b2b41"
                        d="M10.11096,14.23522c-0.55015,1.05848 -1.62709,1.72948 -2.80905,1.72948c-1.18184,0 -2.2589,-0.67099 -2.80905,-1.72948c0.55015,-1.05848 1.62721,-1.72948 2.80905,-1.72948c1.18196,0 2.2589,0.67099 2.80905,1.72948zM8.23807,14.23522c0,-0.52977 -0.41997,-0.96079 -0.93615,-0.96079c-0.51618,0 -0.93615,0.43103 -0.93615,0.96079c0,0.52977 0.41997,0.96079 0.93615,0.96079c0.51618,0 0.93615,-0.43103 0.93615,-0.96079zM14.60384,5.39586v12.87476c0,0.95358 -0.75591,1.72935 -1.68502,1.72935h-11.23381c-0.92912,0 -1.68502,-0.77577 -1.68502,-1.72935v-16.52582c0,-0.95358 0.75591,-1.72935 1.68502,-1.72935h7.86364c0.15295,0 0.29933,0.06399 0.40519,0.17716l4.49359,4.80409c0.10037,0.10726 0.1564,0.25033 0.1564,0.39916zM11.24929,14.46601c0.0627,-0.14713 0.0627,-0.31445 0,-0.46158c-0.68569,-1.6108 -2.23517,-2.65158 -3.94738,-2.65158c-1.7122,0 -3.26157,1.04078 -3.94738,2.65158c-0.06258,0.14713 -0.06258,0.31445 0,0.46158c0.68581,1.6108 2.23517,2.65158 3.94738,2.65158c1.7122,0 3.26169,-1.04078 3.94738,-2.65158zM12.3571,6.54889c0,-0.31838 -0.25141,-0.57658 -0.56171,-0.57658h-2.80833v-2.88237c0,-0.31838 -0.25153,-0.57645 -0.56171,-0.57645c-0.31018,0 -0.56171,0.25806 -0.56171,0.57645v3.45895c0,0.31838 0.25153,0.57645 0.56171,0.57645h3.37005c0.3103,0 0.56171,-0.25806 0.56171,-0.57645z"
                        fill-opacity="1"
                      ></path>
                    </g>
                  </g>
                </svg>
                {{ $t("racunovodstvo_nalozi.open") }}
              </div>
              <div
                class="print-button icon-button"
                @click="downloadNalog(nalog)"
                v-if="downloading != nalog.id_troskovnik"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.6975 0C5.89894 0 5.23277 0.648667 5.16304 1.49419C5.01724 3.26199 4.98035 5.03769 5.05247 6.80992C4.96541 6.81611 4.87837 6.82256 4.79135 6.82928L3.25379 6.94843C2.27103 7.02459 1.72166 8.18923 2.25222 9.07179C3.38376 10.9539 4.84177 12.5902 6.54854 13.8933L7.16454 14.3636C7.66395 14.745 8.33665 14.745 8.83606 14.3636L9.45206 13.8933C11.1588 12.5902 12.6169 10.9539 13.7484 9.07179C14.2789 8.18923 13.7296 7.02459 12.7468 6.94843L11.2093 6.82928C11.1222 6.82256 11.0352 6.81611 10.9481 6.80992C11.0203 5.03768 10.9834 3.26199 10.8376 1.49418C10.7678 0.648661 10.1017 0 9.3031 0H6.6975Z"
                    fill="black"
                  />
                  <path
                    d="M1.54839 15.0855C1.54839 14.6311 1.20177 14.2627 0.774192 14.2627C0.346618 14.2627 0 14.6311 0 15.0855V17.2798C0 18.3402 0.808779 19.1998 1.80645 19.1998H14.1935C15.1912 19.1998 16 18.3402 16 17.2798V15.0855C16 14.6311 15.6534 14.2627 15.2258 14.2627C14.7982 14.2627 14.4516 14.6311 14.4516 15.0855V17.2798C14.4516 17.4313 14.3361 17.5541 14.1935 17.5541H1.80645C1.66393 17.5541 1.54839 17.4313 1.54839 17.2798V15.0855Z"
                    fill="black"
                  />
                </svg>
                {{ $t("racunovodstvo_nalozi.download") }}
              </div>
              <div class="print-button icon-button" v-else>
                <div class="center-spinner">
                  <svg class="dot-spin" viewBox="0 0 50 50">
                    <circle
                      class="path"
                      cx="25"
                      cy="25"
                      r="20"
                      fill="none"
                      stroke-width="5"
                    ></circle>
                  </svg>
                </div>
              </div>
              <div
                class="print-button icon-button"
                @click="openInvoicing(nalog)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                >
                  <g>
                    <g>
                      <path
                        fill="#000"
                        d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                      ></path>
                    </g>
                  </g>
                </svg>
                {{
                  !nalog.is_invoiced
                    ? $t("racunovodstvo_nalozi.izvrsi")
                    : $t("racunovodstvo_nalozi.izvrsi_edit")
                }}
              </div>
            </div>-->
          </div>
        </div>
        <Pagination
          v-show="final_group_array.length != 0"
          ref="paginat"
          :finalni_arr_prikaza.sync="finalni_arr_prikaza"
          :br_redova="3"
          :ukupna_lista="final_group_array"
        />
      </div>
      <div class="racunovodstvo-right troskovnik-report-edit-right">
        <label class="form-label">
          <span></span>
        </label>
        <div class="troskovnik-report-edit-wrapper">
          <div v-if="selected_group" class="right-purchase-wrapp">
            <div :key="key" :class="['']">
              <div class="kalendar-event-details">
                <div class="kalendar-event-title centered">
                  {{ selected_group.name }}
                </div>
                <div class="nalog-person centered">
                  <span class="person-title">{{ $t('components.general.office_management.purchase_group.execution_period') }}: </span>
                  <span class="">
                    {{
                      selected_group.from_timestamp
                        ? `${getDate(selected_group.from_timestamp)}`
                        : ""
                    }}
                    -
                    {{
                      selected_group.deadline_timestamp
                        ? `${getDate(selected_group.deadline_timestamp)}`
                        : ""
                    }}
                  </span>
                </div>
                <div class="event-type-wrapper centered">
                  <div :class="'vrsta-eventa event-red'" v-if="isFinished(selected_group)">{{ $t('components.general.office_management.purchase_group.unfulfilled') }}</div>
                  <div :class="'vrsta-eventa event-green'" v-else>{{ $t('components.general.office_management.purchase_group.fulfilled') }}</div>
                </div>
                <purchase-table
                  @newPurchase="newPurchase"
                  @updateState="editSinglePurchase"
                  @selectEdit = "openEditPurchaseModal"
                  @delete = "deleteSinglePurchase"
                  :stavke="selected_group.office_management_purchases"
                ></purchase-table>
                <div
                  class="nalog-person"
                  v-if="selected_group_links.length > 0"
                >
                  <!-- <span class="person-title"> Prilozi: </span> -->
                  <div class="case-posta inline-arr">
                    <!-- <div v-for="link in selected_group.links" :key="link.id">
                      <a
                        :href="link['@microsoft.graph.downloadUrl']"
                        target="_blank"
                        >{{ link.name }}</a
                      >
                    </div> -->
                    <a
                      class="case-posta-item centered inline-arr"
                      v-for="(doc, key) in selected_group_links"
                      :key="key"
                      :href="doc['@microsoft.graph.downloadUrl']"
                      target="_blank"
                    >
                      <img class="doc-icon" src="@/assets/img/pdf_icon.svg" />
                      <v-tooltip v-if="doc.name.length > 12" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            {{ doc.name.slice(0, 12) }}...
                          </div>
                        </template>
                        {{ doc.name }}
                      </v-tooltip>
                      <div v-else>{{ doc.name }}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="preview-msg">
            Odaberite grupu za nabavku za prikaz detalja
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="delete_group_modal" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t('office_management.purchase.delete_group_confirm') }}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="delete_group_modal = false"
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="deleteGroup()"
          >
            {{ $t("page_2.page_2_3.delete_pop.btn_2") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import financial from "@/apiCallers/promise_handler_db/financial.js";
import admin from "@/apiCallers/promise_handler_db/admin.js";
import $ from "jquery";
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import moment from "moment";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import DataLoader from "@/components/generalComponents/DataLoader";
import CustomSpinner from "@/components/generalComponents/CustomSpinner.vue";
import Pagination from "@/components/generalComponents/Pagination.vue";
import FormFilesUpload from "@/components/formElements/formFilesUpload.vue";
import graph from "../../services/graph";
import PurchaseTable from "./PurchaseTable.vue";
import PurchaseCreateEdit from "./PurchaseCreateEdit.vue";
import {
  createPurchase,
  deletePurchase,
  deletePurchaseGroup,
  updatePurchase,
} from "../../apiCallers/promise_handler_db/officeManagement";

export default {
  name: "PurchaseGroupArray",
  components: {
    CustomDropdown,
    DataLoader,
    CustomSpinner,
    Pagination,
    FormFilesUpload,
    PurchaseTable,
    PurchaseCreateEdit,
  },
  props: ["purchase_groups","services"],
  data() {
    return {
      selected_group: null,
      selected_group_links: [],
      menu1: false,
      all_users: [],
      delete_group_modal : false,
      finalni_arr_prikaza : [],

      selected_person : null,
      selected_type : null,

      refresher_purchaser: 1,

      date_range: [],
      pickerDate: null,
      loading: false,
      fetching: false,
      downloading: null,

      // Purchase start

      active_purchase_popup: false,
      purchase_edit_mode: false,
      purchaseData: {},
      emptyPurchaseData: {
        title: "",
        description: "",
        quantity: 1,
        aquired: false,
        person_id: null,
      },
      // Purchase end
    };
  },
  computed: {
    final_group_array(){
      let final_arr = this.purchase_groups;
      if(this.selected_person)
      {
        console.log(this.selected_person)
        final_arr = (final_arr.filter(p=> p.office_management_purchases.filter(l=> l.person_id == this.selected_person).length > 0));
        
      }
      if(this.selected_type)
      {
        final_arr = (final_arr.filter(p=> p.purchase_type == this.selected_type));
      }

      setTimeout(() => {
                    this.$refs.paginat.calculatePageNumber();
                    this.$refs.paginat.paginirajOdabrane();
                }, 1000);
      return final_arr
    },
    dateRangeText: {
      get() {
        var ret_date_string = [];
        this.date_range.forEach((p) => {
          ret_date_string.push(moment(p).format("l"));
        });
        return ret_date_string.join(" ~ ");
      },
      set(new_val) {
        // console.log(new_val)
        if (new_val == null) {
          this.date_range = [];
        }
      },
    },
  },
  async created() {
    this.loading = true;

  },

  methods: {
    clearAllFilters()
    {
      this.selected_person = null;
      this.selected_type = null;
    },
    isFinished(single_group) {
      return (
        single_group.office_management_purchases.filter((p) => p.aquired)
          .length != single_group.office_management_purchases.length ||
        single_group.office_management_purchases.length == 0
      );
    },
    async refreshSelectedGroup() {
      this.selected_group = this.purchase_groups.find(
        (p) => (p.id ==  this.selected_group.id)
      );
    },
    async createNewPurchase(single_data) {
      single_data["purchase_group_id"] = this.selected_group.id;
      console.log("Create new data", single_data);
      await createPurchase(single_data);

      this.$emit("refreshData");
      setTimeout(() => {
                    this.$refs.paginat.calculatePageNumber();
                    this.$refs.paginat.paginirajOdabrane();
                }, 1000);
      this.closePurchasePop(); //Close the modal
    },
    async editSinglePurchase(single_object) {
      console.log("update single purchase", single_object);
      await updatePurchase(single_object.id, single_object.data);
      this.$emit("refreshData");
      setTimeout(() => {
                    this.$refs.paginat.calculatePageNumber();
                    this.$refs.paginat.paginirajOdabrane();
                }, 1000);
      // this.refreshSelectedGroup()
      this.closePurchasePop();
    },
    openDeleteGroupModal(){
      this.delete_group_modal = true;
    }, 
    async deleteGroup(){
     await deletePurchaseGroup(this.selected_group.id);
      this.selected_group = null;
      this.$emit("refreshData")
      this.delete_group_modal = false;
    },  
    closePurchasePop() {
      this.active_purchase_popup = false;
      this.purchaseData = this.emptyPurchaseData;
    },
    newPurchase() {
      this.purchaseData = this.emptyPurchaseData;
      this.purchase_edit_mode = false;
      this.active_purchase_popup = true;
    },
    openEditPurchaseModal(selected_purchase)
    {
      this.purchase_edit_mode = true;
      this.purchaseData = this.emptyPurchaseData;
      this.purchaseData = selected_purchase
      this.active_purchase_popup = true;

    },
    async deleteSinglePurchase(purchase_id)
    {
      await deletePurchase(purchase_id);
      this.$emit("refreshData");
      setTimeout(() => {
                    this.$refs.paginat.calculatePageNumber();
                    this.$refs.paginat.paginirajOdabrane();
                }, 1000);
    },
    calcAttachments(noa) {
      return noa == 1 ? this.$t('components.general.office_management.purchase_group.attachment_one') : noa + " " + this.$t('components.general.office_management.purchase_group.attachments_multiple');
    },
    openNewModal() {
      this.$emit("openAddNew");
    },
    openEditModal(selected) {
      this.$emit("editModal", selected);
    },

    openBreakdown() {
      setTimeout(() => {
        this.$store.state.breakdown_report_data = {
          breakdown: this.chosen_nalog.breakdown_satnice,
          predmet_data: this.chosen_nalog.predmet,
          punomocnik: this.chosen_nalog.edit_structure.punomoćnik_osoba,
          naziv_dokumenta: this.chosen_nalog.name,
        };
        this.$router.push("/breakdown-report");
      }, 10);
    },

    async setGroupView(sel_group) {
      this.selected_group = { ...sel_group };
      console.log(this.selected_group);
      this.selected_group_links = await graph.getMultipleFiles(
        this.selected_group.links
      );
    },

    getDate(date) {
      return moment(date).format("DD.MM.yyyy.");
    },
    getTime(date) {
      return moment(date).format("HH:mm:ss");
    },
    async getAllUsers() {
      await admin.getUsers().then((resp) => {
        this.all_users = resp.data.all_users.map((p) => {
          return { value: p.ime + " " + p.prezime, link: p.uid };
        });
      });
    },
  },

  watch: {
    date_range: function () {
    },

    purchase_groups: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        // do your stuff
        console.log("change is here", val, oldVal);
        if (this.selected_group) {
          this.refreshSelectedGroup();
        }
      },
    },
  },

  mounted() {
    this.getAllUsers();
  },
};
</script>
